import { Link } from 'react-router-dom';
import {
  BarChart2,
  ToggleRight,
  Sparkles,
  Users,
  Award,
  ShieldCheck,
  Gift,
  UserCircle,
  MessageSquare,
  Image,
  Download,
  Star,
  Flag,
  MapPin,
  ListOrdered,
  LucideIcon,
} from 'lucide-react';
import { useTranslation } from 'react-i18next';

import AdminLayout from '../../components/AdminLayout';

interface LinkCard {
  title: string;
  description: string;
  href: string;
  icon: LucideIcon;
}

function AdminHome() {
  const { t } = useTranslation('admin');

  const cards: LinkCard[] = [
    {
      title: t('home.cards.metrics.title'),
      description: t('home.cards.metrics.description'),
      href: '/admin/metrics',
      icon: BarChart2,
    },
    {
      title: t('home.cards.features.title'),
      description: t('home.cards.features.description'),
      href: '/admin/features',
      icon: ToggleRight,
    },
    {
      title: t('home.cards.sparks.title'),
      description: t('home.cards.sparks.description'),
      href: '/admin/sparks',
      icon: Sparkles,
    },
    {
      title: t('home.cards.users.title'),
      description: t('home.cards.users.description'),
      href: '/admin/users',
      icon: Users,
    },
    {
      title: t('home.cards.badges.title'),
      description: t('home.cards.badges.description'),
      href: '/admin/badges',
      icon: Award,
    },
    {
      title: t('home.cards.verification.title'),
      description: t('home.cards.verification.description'),
      href: '/admin/verification-requests',
      icon: ShieldCheck,
    },
    {
      title: t('home.cards.rewards.title'),
      description: t('home.cards.rewards.description'),
      href: '/admin/rewards',
      icon: Gift,
    },
    {
      title: t('home.cards.moderation.title'),
      description: t('home.cards.moderation.description'),
      href: '/admin/moderation',
      icon: Flag,
    },
    {
      title: t('home.cards.profiles.title'),
      description: t('home.cards.profiles.description'),
      href: '/admin/profiles',
      icon: UserCircle,
    },
    {
      title: t('home.cards.chats.title'),
      description: t('home.cards.chats.description'),
      href: '/admin/chats',
      icon: MessageSquare,
    },
    {
      title: t('home.cards.mocks.title'),
      description: t('home.cards.mocks.description'),
      href: '/admin/mocks',
      icon: Image,
    },
    {
      title: t('home.cards.import-artists.title'),
      description: t('home.cards.import-artists.description'),
      href: '/admin/import-artists',
      icon: Download,
    },
    {
      title: t('home.cards.artist-spotlight.title'),
      description: t('home.cards.artist-spotlight.description'),
      href: '/admin/artist-spotlight',
      icon: Star,
    },
    {
      title: t('home.cards.geographic-centrality.title'),
      description: t('home.cards.geographic-centrality.description'),
      href: '/admin/geographic-centrality',
      icon: MapPin,
    },
    {
      title: t('home.cards.onboarding.title'),
      description: t('home.cards.onboarding.description'),
      href: '/admin/onboarding',
      icon: ListOrdered,
    },
  ];

  return (
    <AdminLayout title={t('home.page-title')} description={t('home.page-description')}>
      <div className="grid gap-4 md:grid-cols-3">
        {cards.map((card) => (
          <Link
            key={card.href}
            to={card.href}
            className="flex items-start gap-4 rounded-lg border border-zinc-200 bg-white p-5 transition-colors hover:border-zinc-300 hover:bg-zinc-50"
          >
            <div className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-zinc-100">
              <card.icon className="h-5 w-5 text-zinc-600" />
            </div>
            <div>
              <h3 className="text-sm font-medium text-zinc-900">{card.title}</h3>
              <p className="mt-1 text-sm text-zinc-500">{card.description}</p>
            </div>
          </Link>
        ))}
      </div>
    </AdminLayout>
  );
}

export default AdminHome;
